module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "50px"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "550px",
      "text-indent": "0px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "550px",
      "height": "2.81in"
    },
    attrs: {
      "alt": "",
      "src": "media/image2.jpeg"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "text-indent": "0px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Pedestrians and cyclist cross a busy traffic artery via a Bridge of Remembrance; made possible by a grant from Australia’s Anzac Centenary Public Fund. Opened in 2019, the bridge links Hobart’s Cenotaph to its Domain ("), _c('em', [_vm._v("above")]), _vm._v("). Designed for the City of Hobart by architects Denton Corker Marshall and an Arup engineering team, the bridge is an elegant outcome of the integration of architecture and engineering. The photo below shows the width of the bridge, designed for use by people of all abilities.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "text-indent": "0px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The wave-like twisted planes that leap 196 metres across the Tasman Highway by rotating along their length have their aesthetic origins in the post-WWII discovery of ‘free’ form. In Hobart, this was exemplified by the large Danish silver ‘Wave Bowl’ by Henning Koppel, exhibited in 1958 (pp 90, 126).")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "text-indent": "0px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("In June 2020, the Tasmanian Chapter of the Australian Institute of Architects selected the bridge for its annual Dirk Bolt Award for Urban Design. The photographs were taken by Craig Garth "), _c('em', [_vm._v("(above)")]), _vm._v(" and Alastair Bett "), _c('em', [_vm._v("(below)")]), _vm._v(" and provided by the City of Hobart, which arranged permission for their use in this last-minute addition to the book.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px",
      "width": "550px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "550px",
      "height": "1.98594in"
    },
    attrs: {
      "alt": "",
      "src": "media/image3.jpeg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd51864a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0006.vue
// module id = 75
// module chunks = 0